module.exports = __webpack_public_path__ + "static/nginx-2b9f5508623ef64f8f0e81ae6bb1fb24.png";